export default __webpack_public_path__ + "static/media/sad_heart.4c9b8fd8.png";